import { ArrowDown, ArrowUp, Equal, Flame } from 'lucide-react'
import { cn } from '../lib/cn'
import type { Priority } from '../data/types'

const config: Record<Priority, { icon: typeof Flame; className: string }> = {
  Low: { icon: ArrowDown, className: 'text-ink-500 bg-ink-100' },
  Medium: { icon: Equal, className: 'text-info-600 bg-info-50' },
  High: { icon: ArrowUp, className: 'text-warning-600 bg-warning-50' },
  Urgent: { icon: Flame, className: 'text-danger-600 bg-danger-50' },
}

export function PriorityBadge({ priority, className }: { priority: Priority; className?: string }) {
  const { icon: Icon, className: styles } = config[priority]
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium whitespace-nowrap',
        styles,
        className,
      )}
    >
      <Icon size={11} strokeWidth={2.5} />
      {priority}
    </span>
  )
}
